export const capitalize = (text) => text.length > 1 ? `${text.charAt(0).toUpperCase()}${text.substr(1)}` : text.toUpperCase();
